@if (!pending) {
    @if (displayEntities.data?.length > 0) {
        <div class="table__container">
            <table class="table w-100" mat-table matSort [dataSource]="displayEntities">
                <ng-container matColumnDef="number">
                    <th class="th--55 text-end" mat-header-cell *matHeaderCellDef>#</th>
                    <td class="text-end text-muted font-size-sm" mat-cell *matCellDef="let item; let i = index">
                        {{ i + 1 + this.displayEntities?.paginator?.pageIndex * this.displayEntities?.paginator?.pageSize }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="period">
                    <th mat-header-cell *matHeaderCellDef>
                        {{ 'global.labels.period' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let item">
                        {{ item.dateFrom | date: dateFormat }}&nbsp;&mdash;&nbsp;{{ item.dateTo | date: dateFormat }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="date">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef>
                        {{ 'global.labels.date' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let item">
                        {{ item.invDate | date: dateFormat }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="amount">
                    <th mat-header-cell mat-sort-header="total" *matHeaderCellDef>
                        {{ 'ui.history-table.amount' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let item">
                        {{ item.total }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="status">
                    <th mat-header-cell mat-sort-header="stCode" *matHeaderCellDef>
                        {{ 'global.labels.status' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let item" [class.text-warning]="item.stCode === 2" [class.text-success]="item.stCode === 3">
                        {{ item.stName }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="icons">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let item">
                        <div class="d-flex flex-nowrap align-items-center justify-content-end" (click)="stopPropagation($event)">
                            <span class="pseudo pseudo--border-off me-3" (click)="changeInvoiceStatus.emit(item)">
                                {{ 'global.labels.changeStatus' | translate }}
                            </span>

                            <a
                                class="a--border-off a--black me-3 a--gray"
                                target="_blank"
                                rel="noopener"
                                [attr.href]="item | urlInvoice | async"
                                [attr.title]="'global.actions.download' | translate">
                                <ui-icon-bs [type]="bsIconTypes.Download" />
                            </a>

                            @if (!readonly && item.stCode === 1) {
                                <ui-icon-bs
                                    [pseudo]="'gray'"
                                    [type]="bsIconTypes.Trash3"
                                    (handlerClick)="handlers.handlerDeleteEntity(item)" />
                            } @else {
                                <i style="width: 20px"></i>
                            }
                        </div>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr class="tr--hover-off" mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
        </div>
    } @else {
        <ui-no-matches [isSearchResults]="true" />
    }
} @else {
    <ui-pre-loader [narrow]="true" />
}
